<template>
  <div v-if="alertes.length" class="reglages-sons">
    <button type="button" class="rs-bascule" :aria-pressed="reglages.actif ? 'true' : 'false'" :aria-expanded="ouvert ? 'true' : 'false'"
      :title="reglages.actif ? 'Sons des alertes activés' : 'Sons des alertes coupés'" @click="ouvert = !ouvert">
      <i :class="['fa', reglages.actif ? 'fa-volume-up' : 'fa-volume-mute']" aria-hidden="true"></i>
      Sons des alertes : {{ reglages.actif ? 'activés' : 'coupés' }}
    </button>
    <div v-if="ouvert" class="rs-panneau" role="dialog" aria-label="Sons des alertes">
      <label class="rs-ligne rs-principal"><input v-model="reglages.actif" type="checkbox" @change="enregistrer"> Activer les sons sur ce poste</label>
      <fieldset :disabled="!reglages.actif" class="rs-groupe">
        <legend>Alertes sonores</legend>
        <div v-for="type in alertes" :key="type" class="rs-ligne rs-alerte">
          <label><input type="checkbox" :checked="reglages.alertes[type] !== false" @change="choisir(type, $event.target.checked)"> {{ libelle(type) }}</label>
          <button type="button" class="rs-tester" :aria-label="'Tester le son : ' + libelle(type)" @click="tester(type)">Tester</button>
        </div>
        <label class="rs-volume">Volume
          <input v-model.number="reglages.volume" type="range" min="0.1" max="1" step="0.1" @change="enregistrer">
        </label>
      </fieldset>
      <p class="rs-aide">Un son retentit quand une nouvelle alerte arrive (pastille du menu qui augmente). Réglage propre à ce poste.</p>
      <p v-if="message" class="rs-message" role="status">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import { SONS, lireReglages, enregistrerReglages, jouer, installerDeverrouillage } from '@/utils/sons-alertes'

// Réglages des sons des alertes (04/10/2026), au pied du menu : activés ou coupés, alertes choisies, volume, test.
export default {
  name: 'reglages-sons',
  props: { alertes: { type: Array, default: () => [] } },
  data() {
    return { reglages: lireReglages(), ouvert: false, message: '' }
  },
  mounted() { installerDeverrouillage() },
  methods: {
    libelle(type) { return (SONS[type] && SONS[type].libelle) || type },
    enregistrer() {
      enregistrerReglages(this.reglages)
      this.$emit('change', this.reglages)
    },
    choisir(type, actif) {
      this.reglages = Object.assign({}, this.reglages, { alertes: Object.assign({}, this.reglages.alertes, { [type]: actif }) })
      this.enregistrer()
    },
    tester(type) {
      this.message = jouer(type, this.reglages, true) ? '' : 'Le navigateur ne peut pas jouer de son : cliquez dans la page puis réessayez.'
    },
  },
}
</script>

<style scoped>
.reglages-sons { margin-bottom: 10px; }
.rs-bascule { display: inline-flex; align-items: center; gap: 8px; min-height: 36px; padding: 6px 12px; border: 1px solid #c7d5f1; border-radius: 999px;
  background: #fff; color: var(--ui-text-secondary, #273449); font-size: 13px; font-weight: 600; }
.rs-bascule i { color: var(--ui-accent, #2457c5); }
.rs-bascule:hover { background: #eaf0ff; }
.rs-panneau { margin-top: 8px; padding: 12px; border: 1px solid #e0e7f3; border-radius: 14px;
  background: #f7f9fd; color: var(--ui-text, #172033); text-align: left; }
.rs-ligne { display: flex; align-items: center; gap: 8px; margin: 0; font-size: 14px; }
.rs-principal { font-weight: 700; margin-bottom: 10px; }
.rs-groupe { margin: 0; padding: 0; border: 0; }
.rs-groupe legend { margin-bottom: 6px; color: var(--ui-text-muted, #526074); font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .03em; }
.rs-alerte { justify-content: space-between; padding: 4px 0; }
.rs-alerte label { display: inline-flex; align-items: center; gap: 8px; margin: 0; }
.rs-tester { min-height: 30px; padding: 3px 12px; border: 1px solid #c7d5f1; border-radius: 999px; background: #fff; color: var(--ui-accent, #2457c5); font-size: 13px; font-weight: 600; }
.rs-volume { display: flex; align-items: center; gap: 10px; margin: 10px 0 0; font-size: 14px; }
.rs-volume input { flex: 1; }
.rs-aide { margin: 10px 0 0; color: var(--ui-text-muted, #526074); font-size: 12px; line-height: 1.4; }
.rs-message { margin: 8px 0 0; color: #8a4b08; font-size: 13px; }
.reglages-sons button:focus-visible, .reglages-sons input:focus-visible { outline: 3px solid #8caaf5; outline-offset: 2px; }
</style>
